var CoordinateSystem = {
  DISPLAY: 0,
  WORLD: 1
};
var Constants = {
  CoordinateSystem: CoordinateSystem
};

export { CoordinateSystem, Constants as default };
